import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import BatchSftpProcessViewForm from './BatchSftpProcessViewForm'
import BatchSftpProcessAddForm from './BatchSftpProcessAddForm'
import BatchSftpProcessEditForm from './BatchSftpProcessEditForm'
import Namespace from 'src/constants/locale/Namespace'
import BatchSftpProcessKeys from 'src/constants/locale/key/BatchSftpProcess'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [id, setId] = useState('')
  const { translate } = useTranslation([
    Namespace.BATCH_SFTP_PROCESS,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let batchSftpProcess = translate(
      Namespace.BATCH_SFTP_PROCESS,
      BatchSftpProcessKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: batchSftpProcess
      }
    )

    return {
      batchSftpProcess,
      tabLockedMessage
    }
  }

  function makeBatchSftpProcessForm() {
    if (id === '') {
      return (
        <BatchSftpProcessAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <BatchSftpProcessEditForm
          showNotification={showNotification}
          id={id}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      {}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.batchSftpProcess,
              tabContent: makeBatchSftpProcessForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage
